import { Base_url } from './Base_url';
const KEY = 'wht.portal.session';
export function readPortalSession() {
  try {
    const session = JSON.parse(sessionStorage.getItem(KEY));
    const account =
      session?.user?.role === 'admin'
        ? localStorage.getItem('adminToken')
        : localStorage.getItem('managerToken');
    return session?.token &&
      session.user?.id === account &&
      new Date(session.expiresAt).getTime() > Date.now()
      ? session
      : null;
  } catch {
    return null;
  }
}
export function savePortalSession(session) {
  if (session) sessionStorage.setItem(KEY, JSON.stringify(session));
  else sessionStorage.removeItem(KEY);
}
export function clearPortalSession() {
  const session = readPortalSession();
  savePortalSession(null);
  if (session?.token) {
    fetch(`${Base_url}/v1/admin/logout`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${session.token}` },
      keepalive: true
    }).catch(() => {});
  }
}
